import api from './api';

export const watcherService = {
  list: (ticketId) => api.get(`/tickets/${ticketId}/watchers`),
  watch: (ticketId) => api.post(`/tickets/${ticketId}/watchers`),
  unwatch: (ticketId) => api.delete(`/tickets/${ticketId}/watchers`),
};
